import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { FieldAgentClient, GetCustomerContactsRequest, PagingParameters, SortParameters, WebTrackUser, SortParametersDirection } from 'ep-bt-field-agent-proxy';
import { EpbtFieldAgentService } from '../../services/epbt-field-agent.service';

@Component({
    selector: 'epbt-fa-customer-contact-list',
    templateUrl: './epbt-fa-customer-contact-list.component.html',
    styleUrls: ['./epbt-fa-customer-contact-list.component.scss']
})
export class EpbtFaCustomerContactListComponent implements OnInit {

    @Input() customerContacts: any[] = [];
    @Input() customerId: number;
    @Input() disabled: boolean = false;
    @Input() isEditable: boolean = true;

    private _selectedCustomerContact: number;
    @Input('selectedCustomerContact') set selectedCustomerContact(value: number) {
        this._selectedCustomerContact = value;
        if (this._selectedCustomerContact) {
            var result = this.customerContacts.filter(x => x.customerContactID == this._selectedCustomerContact);
            this.customerContactChange.emit(result ? result[0] : null);
        }
    }
    get selectedCustomerContact(): number {
        return this._selectedCustomerContact;
    }

    @Output() customerContactChange = new EventEmitter<any>();

    getCustomerContactsRequest: GetCustomerContactsRequest;
    paging: PagingParameters;
    sort: SortParameters;
    webTrackUser: any;
    constructor(private client: FieldAgentClient, private faclient: EpbtFieldAgentService) { }

    ngOnInit() {
        this.GetCustomerContacts();
    }

    onSelectionChange(selectedValue: any) {
        if (selectedValue) {
            this.selectedCustomerContact = selectedValue.customerContactID;
            var result = this.customerContacts.filter(x => x.customerContactID == this.selectedCustomerContact);
            this.customerContactChange.emit(result ? result[0] : null);
        }
    }

    async GetCustomerContacts() {
        this.prepareGetCustomerContactsRequest((request: any) => {
            try {
                this.client.getCustomerContacts(this.getCustomerContactsRequest).subscribe(res => {
                    this.customerContacts = res.lines;
                });
            }
            catch (ex) {
                console.log(ex + "getCustomerContacts");
            }
        });

    }

    prepareGetCustomerContactsRequest(subscribe: (bisTrackSetting: any) => void) {
        this.getCustomerContactsRequest = new GetCustomerContactsRequest();
        this.faclient.getWebTrackUser((webTrackUser: any) => {
            this.webTrackUser = webTrackUser;
            this.getCustomerContactsRequest.currentUser = this.webTrackUser;
            this.getCustomerContactsRequest.currentUser.customer.customerId = this.customerId;

            this.getCustomerContactsRequest.paging = new PagingParameters();
            this.getCustomerContactsRequest.paging.index = 0;
            this.getCustomerContactsRequest.paging.count = 100;

            this.getCustomerContactsRequest.sorting = new SortParameters();
            this.getCustomerContactsRequest.sorting.sortColumn = "name";
            this.getCustomerContactsRequest.sorting.direction = SortParametersDirection.Ascending;

            subscribe(this.getCustomerContactsRequest);
        });
    }
}
